import { connect } from 'react-redux';
import OBSPIE from './OBSPIE';

import { getAnnualResults } from '../../selectors';
import { setSystemProduction } from '../../actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    projectState: state.projectaddress.projectState,
    aFixedCharge: state.utility.aFixedCharge,
    sgipToggle: state.sgip.sgipToggle,
});

const combinedActions = {
    setSystemProduction,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(OBSPIE);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/OBSPIE/index.js